export default __webpack_public_path__ + "static/media/home-decor-img-17.1a6ddda9.jpg";